var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 22.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,7.63a.5.5,0,0,1,.5.5v7.65a.5.5,0,1,1-1,0V8.13A.5.5,0,0,1,11.5,7.63ZM22.93,22.74a.52.52,0,0,1-.43.24H.5a.52.52,0,0,1-.43-.24.53.53,0,0,1,0-.49l11-22a.53.53,0,0,1,.9,0l11,22A.53.53,0,0,1,22.93,22.74ZM21.69,22,11.5,1.6,1.31,22ZM11.5,18a1,1,0,1,1-1,1A1,1,0,0,1,11.5,18Zm.5,1h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.1d607ad88d9b649dedb9c2b781f96358.svg";
export { ForwardRef as ReactComponent };